import * as React from 'react';

import { EntityTabAttachments } from '@rematter/modules/customer-portal/_components/_shared/EntityTabAttachments';
import { useAtomValue, useSetAtom } from 'jotai';

import * as state from '../../_state/loadDetails.state';

export const LoadTabAttachments = () => {
  const loadCustomerFiles = useAtomValue(state.$loadCustomerFiles);
  const uploadProgress = useAtomValue(state.$getUploadProgress);
  const addLoadAttachments = useSetAtom(state.$addLoadAttachments);
  const deleteFile = useSetAtom(state.$deleteLoadFile);

  const files = React.useMemo(
    () => loadCustomerFiles.data ?? [],
    [loadCustomerFiles.data],
  );

  return (
    <EntityTabAttachments
      isLoading={loadCustomerFiles.isLoading}
      files={files}
      uploadProgress={uploadProgress}
      onAddFiles={addLoadAttachments}
      onDeleteFile={deleteFile}
      className="@LoadTabAttachments"
    />
  );
};
